import React from "react";

const PageContainer = ({ children, size = "default", className = "", lang, dir }) => {
  const sizeClass = size === "wide" ? "page-container--wide" : "";
  return (
    <div
      className={`container-box page-container ${sizeClass} ${className}`.trim()}
      {...(lang ? { lang: String(lang) } : {})}
      {...(dir ? { dir: String(dir) } : {})}
    >
      {children}
    </div>
  );
};

export default PageContainer;
